// extracted by mini-css-extract-plugin
export default {"root":"RtDLmSm9ca","list":"IMetQY__Y_","list_hasBorderTop":"DgncTVxCNS","list_hasMobileSpacing":"A0WY5CxCHY","measurement":"QOYa86KrHH"};